// 加入購物車 按鈕功能

document.addEventListener('DOMContentLoaded', function () {
  const toastButtons = document.querySelectorAll('.cartToastBtn');
  const toastLiveExample = document.getElementById('cartToast');

  if (toastButtons.length > 0 && toastLiveExample) {
    const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLiveExample);

    toastButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        toastBootstrap.show();
      });
    });
  }
});


